import { DefaultState, DropdownItem } from 'store/types';
import { ReservationProviderForm } from '../post-reservation-provider/types';

export const GET_RESERVATION_PROVIDER_REQUEST = 'GET_RESERVATION_PROVIDER_REQUEST';
export const GET_RESERVATION_PROVIDER_SUCCESS = 'GET_RESERVATION_PROVIDER_SUCCESS';
export const GET_RESERVATION_PROVIDER_FAILURE = 'GET_RESERVATION_PROVIDER_FAILURE';
export const GET_RESERVATION_PROVIDER_CLEAR = 'GET_RESERVATION_PROVIDER_CLEAR';

export interface ReservationProviderFormData extends ReservationProviderForm {
  statusesSelectList: DropdownItem[];
  requestNumberRequiredSelectList: DropdownItem[];
  lodgingPolicySelectList: DropdownItem[];
}

export type GetReservationProviderState = DefaultState & {
  contents?: ReservationProviderFormData;
};

interface GetReservationProviderRequest {
  type: typeof GET_RESERVATION_PROVIDER_REQUEST;
}

interface GetReservationProviderSuccess {
  type: typeof GET_RESERVATION_PROVIDER_SUCCESS;
  contents: ReservationProviderFormData;
}

interface GetReservationProviderFailure {
  type: typeof GET_RESERVATION_PROVIDER_FAILURE;
}

interface GetReservationProviderClear {
  type: typeof GET_RESERVATION_PROVIDER_CLEAR;
}

export type GetReservationProviderActionTypes = GetReservationProviderRequest | GetReservationProviderSuccess | GetReservationProviderFailure | GetReservationProviderClear;